<template>
  <div class="sales">
    <img src="https://static.hncscm.net/0903-1.jpg" alt="">
    <section>
      <p class="warmtips">温馨提示：新卡新号，24小时内发货！</p>
      <p class="toptips">请填写姓名</p>
      <van-field
        v-model="params.certName"
        label="收件人姓名"
        placeholder="请输入收件人姓名(已加密)"
        input-align="right"
      />
      <van-field
        v-model="params.mobilePhone"
        label="联系号码"
        placeholder="请输入收件人电话，并保持畅通"
        input-align="right"
      />
      <ProvincePicker/>
      <van-field
        v-model="params.address"
        label="详细地址"
        placeholder="街道/镇+村/小区/写字楼+门牌号（不详细，不发货）"
        input-align="right"
      />
      <van-field
        v-model="params.certNo"
        label="办理身份证"
        placeholder="未满16周岁请勿下单"
        input-align="right"
      />
      <p class="tips">
        *请填写真实身份信息，未满16周岁、联系电话错误、收货地址错误或过于简单无法正常发货。收货地址请填写完整。
      </p>
      <van-button class="handle-btn" @click="submit">免费领卡-包邮到家</van-button>
      <p class="protocol"><van-checkbox v-model="checked">我已阅读并同意</van-checkbox> <span>《客户入网服务协议及业务协议》</span></p>
      <p class="protocol"><span>《关于客户个人信息收集、使用规则的公告》</span></p>
    </section>
    <img src="https://static.hncscm.net/0831-3.jpg" alt="">
  </div>
</template>

<script>
import {
  Field,
  CellGroup,
  Button,
  Checkbox
  // Notify
} from 'vant'
import ProvincePicker from '@components/ProvincePicker'
export default {
  data () {
    return {
      checked: true,
      params: {
        certName: '',
        mobilePhone: '',
        address: '',
        certNo: '',
      }
    }
  },
   methods: {
    submit (value) {
      console.log(111)
    }
  },
  components: {
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    ProvincePicker
  }
}
</script>

<style lang="less" scoped src="./style.less"/>
